import { render, staticRenderFns } from "./CategoryTab.vue?vue&type=template&id=f2898b32&scoped=true"
import script from "./CategoryTab.vue?vue&type=script&lang=js"
export * from "./CategoryTab.vue?vue&type=script&lang=js"
import style0 from "./CategoryTab.vue?vue&type=style&index=0&id=f2898b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2898b32",
  null
  
)

export default component.exports